module.exports = __webpack_public_path__ + "static/img/6areaB_4.ed1e5be.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/6areaB_4.png
// module id = 1207
// module chunks = 1